
import comLeaveWord from '../../components/com-leave-word';
import comRichtext from '@/components/com-richtext.vue';
export default {
	name: 'PostSale',
	data () {
		return {
			tab: {
				list: [
					{name: '售后评价'},
				],
				idx: 0,
			},
			saleDetail:{},
			type:'',//15-示范售后；16-售后评价
			chatId:'',
			source:'BZZX',
		}
	},
	mounted(){
		this.chatId=this.$route.query.id;
		this.getData();
	},
	components:{
		comLeaveWord,
		comRichtext,
	},
	methods: {

		getData () {
			this.type=this.$route.query.type;
			if(this.type=='15'){
				this.tab.list=[{name:'维修案例'}];
				var id = this.chatId;
				var body={
					id:id,
					sslmCode:this.type,
				};
				this.get(this.api.getPageAfterSaleDtoOne,body).then(res=>{
					if(res.result==200){
						this.saleDetail=res.data;
						// this.$forceUpdate();
					}
				}).catch();
			}else{
				var id = this.$route.query.id;
				var body={
					id:id,
					sslmCode:this.type,
				};
				this.get(this.api.getEvaluateOne,body).then(res=>{
					if(res.result==200){
						this.saleDetail=res.data;
						// this.$forceUpdate();
					}
				}).catch();
			}
			
		},


		// 设置下标
		setTabIdx (idx) {
			this.tab.idx = idx;
		},
	}
}

